import { EnhancedVideoJsPlayer } from 'video.js';
import PlayerSettings from '#modules/player/settings/PlayerSettings';
import { logger } from '#utils';

const restorePlayerVolume = (player: EnhancedVideoJsPlayer) => {
  const muted = Boolean(PlayerSettings.get('muted') ?? false);
  const volume = Number(PlayerSettings.get('volume') ?? 1);

  player.muted(muted);
  player.volume(volume);

  logger.info('Audio settings restored', { muted, volume });
};

export default restorePlayerVolume;
